// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.w-list-item[data-v-506e3b52]{ padding: 0 0 0 5px; color:var(--main-blue-3); min-height: 35px\n}\n.w-list-item[data-v-506e3b52]:hover{ background: none;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
